import { useCallback, useRef } from 'react';
const useDebounceFunction = (callback, delay, isTrailingEdge = true) => {
    const timeoutRef = useRef(null);
    const isCalledRef = useRef(false);
    return useCallback((...args) => {
        if (!isTrailingEdge) {
            if (!timeoutRef.current) {
                callback(...args);
                isCalledRef.current = true;
            }
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                isCalledRef.current = false;
            }, delay);
        }
        else {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => callback(...args), delay);
        }
    }, [callback, delay, isTrailingEdge]);
};
export default useDebounceFunction;
